// extracted by mini-css-extract-plugin
export default {"container":"Map_container__n-Dh7","map":"Map_map__UvtQU","no_floor":"Map_no_floor__AzAVn","dabeeo":"Map_dabeeo__qp5rr","qr_wrapper":"Map_qr_wrapper__Cofs-","text":"Map_text__MzQRu"};